export const CLEVER_TAP_EVENTS_CONSTANTS = Object.freeze({
    // Invoice page related events
    invoice: {
        submit_invoiceproof: 'submit_invoiceproof',
        invoice_unblocked: 'invoice_unblocked',
        invoice_soa: 'invoice_soa'
    }
})